<template>
    <div>
        <headerNav title="意见及反馈" />
        <div class="mains">
             <div class="main" @click="goto('/ideal')">
            <div class="main-info">
                <div class="main-info-img" :style="{'background-color':$abctheme.basecolor}">
                    <van-icon
                        :size="28"
                        color="#fff"
                        class-prefix="abc-icon"
                        name="chuangjiankecheng"
                    />
                </div>
                <div class="main-info-wz">
                    创建意见及反馈
                </div>
            </div>
        </div>

        <div class="main"  @click="goto('/ideallist')">
                <div class="main-info">
                    <div class="main-info-img" :style="{'background-color':$abctheme.basecolor}">
                        <van-icon
                        :size="28"
                            color="#fff"
                            class-prefix="abc-icon"
                            name="peixunkechengshenqing"
                        />
                    </div>
                     <div class="main-info-wz">
                        我的意见及反馈
                    </div>
                </div>
        </div>

        </div>
       
    </div>
</template>
<script>
export default {
    data(){
        return{
            queryinput: {
                sorting: "",
                maxResultCount: 10,
                skipCount: 0,
                isAnswer:true,
                isRead:false
            },
            totalcount:0
        }
    },
    created(){
        this.getcountnum();
    },
    methods:
    {
        getcountnum()
        {
             this.ajax.post('/api/services/app/PhoneCom/QueryReadCount?id='+item.id).then(x=> 
             {
                 this.totalcount=x.result;
             });
        },
        
        goto(url)
        {
            this.$router.push({
                path:url ,
            });
        },

    }
}
</script>
<style lang="scss" scoped>
.mains{
    margin-top: 10px;
}
.main{
    padding: 10px 20px;
    text-align: center;
    font-size: 22px;
}
.main-info{
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 1px 1px 4px #cdcdcd;
    padding: 10px;
    margin: 0 10px;
}
.main-info-img{
    display: inline-block;
    border-radius: 50%;
    padding: 20px;
    margin-bottom: 5px;
    text-align: center;
}
.main-info-img i{
    vertical-align: middle;
}
.main-info-wz{
    font-size: 18px;
}
</style>